module.exports = __webpack_public_path__ + "static/media/right-2.63158e11.jpg";